import { render } from "./SectionLC.vue?vue&type=template&id=4c6a2232"
const script = {}

import "./SectionLC.vue?vue&type=style&index=0&id=4c6a2232&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__